<template>
  <BaseInnerLoading />
</template>

<script setup lang="ts">
import { ApiError } from "@/api"
import { logInMerchantGroupMagicLink } from "@/services/merchantGroup/logInMerchantGroupMagicLink"

const router = useRouter()
const token = useRouteQuery<string | null>("token")
const { setToken } = useAuth()

onMounted(async () => {
  if (token.value) {
    try {
      await logInMerchantGroupMagicLink(token.value)
      router.push({ name: "merchantGroupDashboard" })
    } catch (error) {
      logError(error)
      router.push({ name: "loginMerchantGroup" })
      if (error instanceof ApiError) {
        if (error.code === "token-expired") {
          toast.error("Access link has expired", 5000)
        } else {
          toast.error("Failed to log in")
        }
      }
    }
  } else {
    setToken(null)
    router.push({ name: "loginMerchantGroup" })
  }
})
</script>
